import { getEmailFromStorage, getFirstNameFromStorage, persistAuthUser } from '../../../utils/helper';
import { apiFetch, getApiHeaders, getToken } from '../../../utils/api';
import config from '../../../config';
import { DOCK_PORTAL_ID, EMBED_SRC, SCRIPT_ID, TAWK_Z_INDEX } from './constants';
import { bindTawkPhoneCapture } from './phone';
import { callTawk, tawk } from './session';

function readTawkVisitor() {
  const name = getFirstNameFromStorage();
  const email = getEmailFromStorage();
  const visitor = {};
  if (name) visitor.name = name;
  if (email) visitor.email = email;
  return Object.keys(visitor).length ? visitor : null;
}

export function syncTawkVisitor(api = typeof window !== 'undefined' ? window.Tawk_API : null) {
  if (!api) return;
  const visitor = readTawkVisitor();
  if (!visitor) return;
  api.visitor = { ...(api.visitor || {}), ...visitor };
  if (typeof api.setAttributes !== 'function') return;
  try {
    api.setAttributes(visitor, () => {});
  } catch {
    // ignore
  }
}

export async function ensureVisitorEmail(signal) {
  if (getEmailFromStorage()) {
    syncTawkVisitor();
    return;
  }
  const token = getToken();
  if (!token) return;
  try {
    const url = `${config.API_BASE_URL}${config.API_ENDPOINTS.USER_GET_SETTINGS}`;
    const response = await apiFetch(url, {
      method: 'GET',
      headers: getApiHeaders({ 'Content-Type': 'application/json' }, token),
      ...(signal && { signal }),
    });
    if (!response.ok) return;
    const data = await response.json();
    const email = data?.data?.personal_info?.email;
    if (typeof email === 'string' && email.trim()) {
      persistAuthUser({ email: email.trim() });
      syncTawkVisitor();
    }
  } catch {
    // Chat still works without a prefilled email.
  }
}

export function ensureTawkApi() {
  window.Tawk_API = window.Tawk_API || {};
  window.Tawk_LoadStart = window.Tawk_LoadStart || new Date();
  const api = window.Tawk_API;
  if (!api.customStyle) {
    api.customStyle = {
      zIndex: TAWK_Z_INDEX,
      visibility: {
        desktop: { position: 'br', xOffset: 18, yOffset: 18 },
        mobile: { position: 'br', xOffset: 8, yOffset: 8 },
      },
    };
  }
  if (!api.onBeforeLoad) {
    api.onBeforeLoad = function () {
      if (!tawk.wantVisible) callTawk('hideWidget');
    };
  }
  syncTawkVisitor(api);
  bindTawkPhoneCapture(api);
  return api;
}

export function loadTawkScript() {
  if (document.getElementById(SCRIPT_ID)) return;
  const script = document.createElement('script');
  script.id = SCRIPT_ID;
  script.async = true;
  script.src = EMBED_SRC;
  script.charset = 'UTF-8';
  script.setAttribute('crossorigin', '*');
  const first = document.getElementsByTagName('script')[0];
  if (first && first.parentNode) first.parentNode.insertBefore(script, first);
  else document.head.appendChild(script);
}

export function getOrCreateDockPortal() {
  let el = document.getElementById(DOCK_PORTAL_ID);
  if (!el) {
    el = document.createElement('div');
    el.id = DOCK_PORTAL_ID;
    document.documentElement.appendChild(el);
  }
  return el;
}
